<template>
  <div class="contract-name">
    <template>
      <!--待我签-->
      <template v-if="signInfo.signStatus === 0">
        <el-tooltip
          v-if="signInfo.selfSign === 1"
          effect="dark"
          :content="signInfo.contractName"
          placement="bottom-start"
        >
          <span
            @click="
              toSign({
                signNo: signInfo.signNo,
                applyNo: signInfo.applyNo,
                approveId: signInfo.approveId,
                aiCorpUserIdFlag: signInfo.aiCorpUserIdFlag,
                fromDingTalk:signInfo.fromDingTalk
              })
            "
          >{{ signInfo.contractName }}</span>
        </el-tooltip>
        <el-tooltip v-else effect="dark" :content="signInfo.contractName" placement="bottom-start">
          <span @click="
              toApplyDetail()
            ">{{ signInfo.contractName }}</span>
        </el-tooltip>
      </template>
      <!--已结束-->
      <template v-else-if="[1,-5,2,4].includes(signInfo.signStatus)
        ">
        <el-tooltip effect="dark" :content="signInfo.contractName" placement="bottom-start">
          <span @click="
              toApplyDetail()
            ">{{ signInfo.contractName }}</span>
        </el-tooltip>
      </template>
      <!--已过期-->
      <template v-else-if="signInfo.signStatus === -6">
        <el-tooltip effect="dark" :content="signInfo.contractName" placement="bottom-start">
          <span @click="$message.error('文件已过期')">
            {{
            signInfo.contractName
            }}
          </span>
        </el-tooltip>
      </template>
      <!--审批中-->
      <template v-if="signInfo.signStatus === -3">
        <el-tooltip
          v-if="signInfo.selfApprove === 1"
          effect="dark"
          :content="signInfo.contractName"
          placement="bottom-start"
        >
          <span
            @click="
              toAudit({
                signNo: signInfo.signNo,
                applyNo: signInfo.applyNo,
                approveId: signInfo.approveId,
                aiCorpUserIdFlag: signInfo.aiCorpUserIdFlag,
                fromDingTalk: signInfo.fromDingTalk,
              })
            "
          >{{ signInfo.contractName }}</span>
        </el-tooltip>
        <el-tooltip v-else effect="dark" :content="signInfo.contractName" placement="bottom-start">
          <span @click="
              toApplyDetail()
            ">{{ signInfo.contractName }}</span>
        </el-tooltip>
      </template>
      <!-- 审批驳回 -->
      <template v-if="signInfo.signStatus === -4">
        <el-tooltip effect="dark" :content="signInfo.contractName" placement="bottom-start">
          <span @click="
              toApplyDetail()
            ">{{ signInfo.contractName }}</span>
        </el-tooltip>
      </template>
    </template>
  </div>
</template>

<script>
import {
  ApiCorpMethods,
  signViewUrl,
  applyViewUrl,
  signAudit,
  applyAudit
} from "@/assets/js/http-serve/corp/http-methods";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk, authentication } from '../../assets/js/utils/ding-env';

export default {
  name: "corpContractName",
  props: {
    signInfo: {
      type: Object
    },
    applyType: {
      type: String
    }
  },
  computed: {
    viewUrl () {
      if (this.applyType === "signList") {
        return signViewUrl;
      } else if (this.applyType === "applyList") {
        return applyViewUrl;
      } else if (this.applyType === "iApplyList") {
        return ApiMethods.UserApplySignController.viewUrl;
      }
    }
  },
  methods: {
    // 前往签署
    toSign ({ signNo, applyNo, approveId, aiCorpUserIdFlag, fromDingTalk }) {
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((applyNo && applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      ApiCorpMethods.UserApplySignController.postSignUrl(signNo)
        .then(res => {
          if (res.success) {
            let path = this.signInfo.multiFile
              ? "/initiation/viewDetail"
              : "/signInfo/viewDetail";
            res.data.approveId = approveId;
            let router = this.$router.resolve({
              path: path,
              query: {
                ...res.data,
                aiCorpUserIdFlag: aiCorpUserIdFlag
              }
            });
            if (isInDingTalk) {
              this.$router.push({
                path: path,
                query: {
                  ...res.data,
                  aiCorpUserIdFlag: aiCorpUserIdFlag
                }
              })
            } else {
              let new_window = window.open("", "_blank");
              let href = window.location.origin + router.href;
              new_window.location.href = href;
            }
            // 设置token
            localStorage.setItem("JZQ_SIGN_TOKEN_KEY", res.data.tokenKey);
            localStorage.setItem("JZQ_SIGN_TOKEN", res.data.token);
          } else {
            if (res.code === "11016") {
              this.$confirm(
                '<p style="font-size: 16px;">是否继续？</p><p style="font-size: 12px;color: #a2a2a2; line-height: 20px;">您没有用章权限，仅能查看文件内容，如需签署请联系企业管理员获取用章权限。如您是管理员，请前往企业控制台“印章及授权”菜单，将需要使用的印章授权给自己。</p>',
                {
                  distinguishCancelAndClose: true,
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }
              )
                .then(() => {
                  this.toApplyDetail();
                })
                .catch(() => { });
            } else {
              this.$message.error(res.description);
            }
          }
        })
        .catch(err => {
          new_window.close();
          console.log(err);
          this.$confirm(err.description, "系统提示", {
            confirmButtonText: "确定",
            type: "warning"
          }).then(() => { });
        });
    },
    // 前往合同详情
    toApplyDetail () {
      const { signNo, applyNo, approveId, aiCorpUserIdFlag, fromDingTalk, multiFile } = this.signInfo;
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((applyNo && applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      if (isInDingTalk && !fromDingTalk && this.signInfo.signStatus === -3) return this.$message.warning('当前合同请前往君子签Web端处理！')
      if (!isInDingTalk && (fromDingTalk && fromDingTalk === 1) && this.signInfo.signStatus === -3) return this.$message.warning('当前合同请前往钉钉微应用处理！');
      let param = {
        signNo,
        applyNo,
        approveId: approveId || '',
        multiFile
      };
      let newWindow = null;
      if (this.applyType === 'iApplyList') {
        param.corpQuery = 1;
      }
      // 两种接口（发起、收到）方法
      this.viewUrl(param)
        .then(
          url => {
            console.log('toApplyDetail_url:', url);
            if (this.applyType === "iApplyList") {
              let data = url.data;
              let newWindow;
              if (!isInDingTalk) newWindow = window.open();
              let path = this.signInfo.multiFile
                ? "/applySign/toDetailMultiAnony"
                : "/applySign/toDetailAnony";
              data.approveId = approveId;
              let router = this.$router.resolve({ path: path, query: data });
              let href = window.location.origin + router.href;
              // 如果是钉钉环境就走 location 不要 window.open
              isInDingTalk ? this.$router.push(url) : newWindow.location.href = href
            } else {
              if (!isInDingTalk) newWindow = window.open();
              const path = aiCorpUserIdFlag
                ? url + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
                : url;
              isInDingTalk ? this.$router.push(url) : newWindow.location.href = path
            }
          }
        )
        .catch(err => {
          if (!isInDingTalk) {
            console.log('toApplyDetail事件异常捕获：', err);
            if (err && !err.success) this.$message.error(err.description)
          }
        });
    },
    toAudit ({ applyNo, signNo, approveId, aiCorpUserIdFlag, fromDingTalk }) {
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((applyNo && applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      if (isInDingTalk && !fromDingTalk && this.signInfo.signStatus === -3) return this.$message.warning('当前合同请前往君子签Web端处理！')
      if (!isInDingTalk && (fromDingTalk && fromDingTalk === 1) && this.signInfo.signStatus === -3) return this.$message.warning('当前合同请前往钉钉微应用处理！');
      let param = {
        signNo: signNo,
        applyNo: applyNo,
        approveId: approveId,
        multiFile: this.signInfo.multiFile
      };
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();
      signAudit(param)
        .then(url => {
          console.log('url:', url);
          let href = aiCorpUserIdFlag
            ? url + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
            : url;
          isInDingTalk ? this.$router.push(url) : newWindow.location.href = href
        })
        .catch(err => {
          if (!isInDingTalk) newWindow.close();
          console.error("toAudit: " + JSON.stringify(err));
        });
    },
    toApplyAudit ({ applyNo, signNo, approveId }) {
      let param = {
        signNo: signNo,
        applyNo: applyNo,
        approveId: approveId,
        multiFile: this.signInfo.multiFile
      };
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();
      applyAudit(param)
        .then(url => {
          isInDingTalk ? location.href = url : newWindow.location.href = url;
        })
        .catch(err => {
          if (!isInDingTalk) newWindow.close();
          console.error("toAudit: " + JSON.stringify(err));
        });
    }
  },
  mounted () {
  }
};
</script>

<style lang="less" scoped>
.contract-name {
  line-height: 30px;
  overflow: hidden;
  /*max-width: 60%; // 解决safari下太宽问题*/

  & > span {
    max-width: 100%;
    display: inline-block;
    padding: 3px 0;
    line-height: 1;
    vertical-align: middle;
    cursor: pointer;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-y: hidden;
    color: #290202;
    font-weight: 800;
    font-size: 16px;

    &:hover {
      border-bottom: solid 1px #ec1c1c;
      color: #ec1c1c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/corpContractName.vue